import React, { useState, useEffect, useRef } from "react";
import { Header } from "./components/common/header";
import { Footer } from "./components/common/footer";
import { Home } from "./components/home/home";
import SideBarMenu from "./components/common/SideBarMenu";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Terms from "./components/Terms";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Profile from "./components/profile/Profile";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import MobileOtp from "./components/common/MobileOtp";
import Signup from "./components/common/Signup";
import Login from "./components/common/Login";
import CompletionPopup from "./components/common/CompletionPopup";
import ForgotPasswordModal from "./components/common/ForgotPasswordModal";
import Deposit from "./components/transactions/deposit/Deposit";
import Withdraw from "./components/transactions/withdraw/Withdraw";
import PaymentCompletion from "./components/common/PaymentCompletion";
import TableGames from "./components/games/TableGames";
import Game from "./components/games/Game";
import FiltersMenu from "./components/games/FiltersMenu";
import Headlines from "./components/common/Headlines";
import LoginForm from "./components/common/LoginForm";
import { useMediaQuery } from "react-responsive";
import SignupForm from "./components/common/SignupForm";
import UsernameSetup from "./components/common/UsernameSetup";
import {
  openSignupModal,
  closeSignupModal,
} from "./features/slices/ModalSlice";
import {
  updateSelectedItem,
  showChatBoxInDesktop,
  hideChatBoxDesktop,
} from "./features/slices/CommonSlice";
import MobileOtpForm from "./components/common/MobileOtpForm";
import ProfilePhone from "./components/mobile/Profile";
import MobileDeposit from "./components/mobile/transactions/Deposit";
import Completed from "./components/common/Completed";
import MobileWithdraw from "./components/mobile/transactions/Withdraw";
import ForgotPasswordActions from "./components/common/ForgotPasswordActions";
import Loader from "./components/common/Loader";
import Thanks from "./components/common/Thanks";
import MpinSetupPrompt from "./components/common/MpinSetupPrompt";
import RegisterSuccessPrompt from "./components/common/RegisterSuccessPrompt";
import SetMpinModal from "./components/common/SetMpinModal";
import ProtectedRoute from "./app/ProtectedRoute";
import {
  checkUserLogin,
  relogin,
  logoutUser,
  loginUser,
  getUserData,
} from "./features/slices/UserSlice";
// TODO: Re-enable when /games/categories and /games/providers APIs are ready
// import { fetchCategories, fetchProviders } from "./features/slices/GamesSlice";
import { loadRegistrationConfig } from "./features/slices/AppConfigSlice";
import PlayGame from "./components/games/PlayGame";
import AllGames from "./components/games/AllGames";
import {
  closeLoginModal,
  openUsernameSetupModal,
} from "./features/slices/ModalSlice";

import { getUserInfo } from "./app/utils";
import NewBankAccount from "./components/profile/NewBankAccount";
import MobileFooterMain from "./components/mobile/MobileFooterMain";
import Cookies from "js-cookie";
import ChatBox from "./components/common/ChatBox";
import chatBoxIcon from "./assets/images/supportIcon_box.png";
import { clearLocalStoragePreservingAppKeys } from "./utils/rememberMe";
import { buildPlayGameUrl } from "./utils/playGameUrl";
import KeepWorkingPopup from "./components/common/KeepWorkingPopup";
import PaymentStatus from "./components/common/PaymentStatus";
import Astrology from "./components/astrology/Astrology";
import AstroError from "./components/astrology/AstroError";
import PlayAviatrix from "./components/games/PlayAviatrix";
import Matka from "./components/games/Matka";

/** How long before the access token expires the session warning is shown. */
const SESSION_WARNING_MS = 5 * 60 * 1000;

// full-screen launcher pages: no footer, the iframe owns the viewport
const LAUNCHER_PATHS = ["/play-game", "/sports"];

function App() {
  const dispatch = useDispatch();
  const playingGame = LAUNCHER_PATHS.some((path) =>
    window.location.pathname.startsWith(path)
  );
  const modal = useSelector((state) => state.modal);
  const profile = useSelector((state) => state.profile);
  const user = useSelector((state) => state.user);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const common = useSelector((state) => state.common);
  const payment = useSelector((state) => state.payment);
  const game = useSelector((state) => state.game);
  const isLoading = useSelector((state) => state.loading.isLoading);
  const [userInfo, setUserInfo] = useState(null);
  const [inActive, setInActive] = useState(true);
  const [noActivity, setNoActivity] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);
  const [showUsernameSetup, setShowUsernameSetup] = useState(false);
  // const [alreadyPlaying, setShowAlreadyPlaying] = useState(false);

  const idleTimeoutRef = useRef(null);
  const sessionTimerRef = useRef(null);

  const handleMouseMovement = () => {
    setInActive(false);
    clearTimeout(idleTimeoutRef.current);
    clearInterval(idleTimeoutRef.current);
    // Set a new timeout to check for idle after 1 hour (3600000 milliseconds)
    idleTimeoutRef.current = setTimeout(logUserInactive, 300 * 1000);
  };

  const logUserInactive = () => {
    console.log("User has been inactive for 1 minute.");
    setNoActivity(true);
  };

  useEffect(() => {
    // Check if the URL contains `/refer/`
    const path = window.location.pathname;
    if (path.includes("/refer/")) {
      // Open the signup modal if referral link is detected
      dispatch(updateSelectedItem("signup"));
      dispatch(openSignupModal());
    } else {
      dispatch(closeSignupModal());
    }
    dispatch(updateSelectedItem(null));
    dispatch(checkUserLogin());
    dispatch(loadRegistrationConfig());
    // dispatch(fetchCategories());
    // dispatch(fetchProviders());
    getUserInfo()
      .then((data) => {
        setUserInfo(data);
        console.log("info", data);
      })
      .catch((error) => console.error("Error retrieving user info:", error));

    window.onbeforeunload = () => {
      localStorage.removeItem("initialLoad");
    };
    if (!window.location.pathname.includes("profile")) {
      localStorage.removeItem("profileScreen");
      localStorage.removeItem("mobileProfileScreen");
    }
  }, [dispatch]);

  useEffect(() => {
    if (inActive && isMobile) {
      clearInterval(idleTimeoutRef.current);
      idleTimeoutRef.current = setInterval(logUserInactive, 10000);
    }
  }, [inActive]);
  useEffect(() => {
    const isJwtInvalid =
      user.error === "JWT Token Invalid." ||
      payment.error === "JWT Token Invalid." ||
      game.error === "JWT Token Invalid.";
    if (isJwtInvalid) {
      dispatch(relogin());
      Cookies.remove("refreshToken");
      Cookies.remove("tokenExpires");
      clearLocalStoragePreservingAppKeys();
      window.location.reload();
    }
  }, [user.error, payment.error]);

  useEffect(() => {
    if (user.userLoggedIn) {
      sessionStorage.setItem("userIsActive", true);
      localStorage.setItem("initialLoad", true);
      document.addEventListener("mousemove", handleMouseMovement);
      document.addEventListener("touchstart", handleMouseMovement);

      dispatch(
        getUserData({
          source: window.location.href.includes("/play-game")
            ? "play_game"
            : "games_page",
          showLoader: true,
        })
      );
      // dispatch(getCountryList());
      setTimeout(() => {
        dispatch(closeLoginModal());
      }, 500);
      if (localStorage.getItem("game")) {
        const game = JSON.parse(localStorage.getItem("game"));
        const playUrl =
          buildPlayGameUrl(game) || `/play-game/${game.opentableId}`;
        window.open(playUrl, "_blank");
      }
      localStorage.removeItem("game");
    }
  }, [user.userLoggedIn]);

  const toggleChatBox = () => {
    if (common.chatBoxDesktop) {
      dispatch(hideChatBoxDesktop());
    } else {
      dispatch(showChatBoxInDesktop());
    }
  };

  useEffect(() => {
    if (user.alreadyLoggedData.alreadyLoggedIn) {
      dispatch(closeLoginModal());
    }
  }, [user.alreadyLoggedData]);
  useEffect(() => {
    if (user.loggedOut) {
      Cookies.remove("token");
      Cookies.remove("refreshToken");
      window.location.reload();
    }
  }, [user.loggedOut]);
  // Read during render so a renewed token (new expiry) restarts the watcher.
  const sessionExpiresAt = Cookies.get("tokenExpires");

  useEffect(() => {
    clearInterval(sessionTimerRef.current);

    const hasSession = Cookies.get("refreshToken") && Cookies.get("token");
    const expiresAtMs = sessionExpiresAt
      ? new Date(sessionExpiresAt).getTime()
      : 0;

    if (!hasSession || !expiresAtMs || Number.isNaN(expiresAtMs)) {
      setTokenExpired(false);
      return undefined;
    }

    // The expiry moved forward (login or "Keep Playing"), so start over.
    setTokenExpired(false);

    const logout = () => {
      dispatch(logoutUser());
      setTokenExpired(false);
      clearLocalStoragePreservingAppKeys();
      sessionStorage.clear();
    };

    const checkTokenExpiration = () => {
      const remainingMs = expiresAtMs - Date.now();
      if (remainingMs <= 0) {
        clearInterval(sessionTimerRef.current);
        logout();
        return;
      }
      if (remainingMs <= SESSION_WARNING_MS) setTokenExpired(true);
    };

    checkTokenExpiration();
    sessionTimerRef.current = setInterval(checkTokenExpiration, 1000);

    return () => clearInterval(sessionTimerRef.current);
  }, [sessionExpiresAt, user.userLoggedIn, dispatch]);

  const closeKeepWorkingModal = () => {
    setTokenExpired(false);
  };

  useEffect(() => {
    if (
      user.alreadyLoggedData.alreadyLoggedIn &&
      user.showAlreadyLoginMessage
    ) {
      const refreshToken = Cookies.get("refreshToken");
      const payload = {
        grantType: "refreshToken",
        refreshToken: refreshToken || "",
      };
      dispatch(loginUser(payload));
    }
  }, [user.alreadyLoggedData.alreadyLoggedIn, user.showAlreadyLoginMessage]);

  useEffect(() => {
    if (!modal.thanksPopupVisible && localStorage.getItem("showUsernameSetup")) {
      dispatch(openUsernameSetupModal());
      localStorage.removeItem("showUsernameSetup");
    }
  }, [modal.thanksPopupVisible, dispatch]);

  return (

    <Router>
      {/* {user.alreadyLoggedData.alreadyLoggedIn &&
        user.showAlreadyLoginMessage && <AlreadyLoggedInMessagePopup />} */}

      {tokenExpired && <KeepWorkingPopup closeModal={closeKeepWorkingModal} />}
      {common.chatBoxDesktop && !isMobile && <ChatBox />}
      <ConditionalChatIcon isMobile={isMobile} toggleChatBox={toggleChatBox} />
      {isLoading && <Loader />}
      {profile.addBankModal && <NewBankAccount />}
      {modal.openCompletionModal && <CompletionPopup />}
      {modal.mpinSetupPromptVisible && <MpinSetupPrompt />}
      {modal.registerSuccessPromptVisible && <RegisterSuccessPrompt />}
      {modal.setMpinModalVisible && <SetMpinModal />}
      {modal.thanksPopupVisible && <Thanks />}
      {showUsernameSetup && <UsernameSetup />}
      {!isMobile && (
        <div className="desktop-content">
          {modal.isMobileOtpModalVisible && <MobileOtp />}
          {modal.isSingupModalVisible && <Signup />}
          {modal.isLoginModalVisible && <Login />}
          {modal.showForgotPasswordModal && <ForgotPasswordModal />}
          {modal.paymentModal === "Deposit" && <Deposit />}
          {modal.paymentModal === "Withdraw" && <Withdraw />}
          {modal.paymentType && <PaymentCompletion />}
          {modal.thanksPopupVisible && <Thanks />}
          {modal.openUsernameSetupModal && <UsernameSetup />}
        </div>
      )}
      {isMobile && modal.isLoginModalVisible && <Login />}

      <ScrollToTop selectedItem={common.selectedItem} />
      <ConditionalTopNav />
      {common.selectedItem === "chat-bot" && isMobile && <ChatBox />}
      {common.selectedItem === null && !common.chatBox && (
        <>
          <ConditionalHeadlines />
          <Routes>
            <Route exact path="/" element={<Home />}></Route>\
            <Route exact path="/terms" element={<Terms />}></Route>
            <Route
              exact
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            ></Route>
            <Route exact path="/all-games" element={<AllGames />}></Route>
            <Route exact path="/matka" element={<Matka />}></Route>
            <Route exact path="/makta" element={<Matka />}></Route>
            {/* <Route exact path="/astrology" element={<Astrology />}></Route> */}
            <Route exact path="/player-status" element={<AstroError />}></Route>
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  {isMobile ? <ProfilePhone /> : <Profile />}
                </ProtectedRoute>
              }
            />
            <Route
              path="/play-game/:id"
              element={
                <ProtectedRoute>
                  <PlayGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sports"
              element={
                <ProtectedRoute>
                  <PlayGame sports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/astrology"
              element={
                <ProtectedRoute>
                  <Astrology />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play-aviatrix"
              element={
                <ProtectedRoute>
                  <PlayAviatrix />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-status"
              element={
                <ProtectedRoute>
                  <PaymentStatus />
                </ProtectedRoute>
              }
            />
            <Route exact path="/:id" element={<TableGames />}></Route>
            <Route exact path="/:id/:id" element={<Game />}></Route>
          </Routes>
        </>
      )}
      <div className="mobile-content">
        {common.selectedItem === "filter" && (
          <div className="mobile-filters">
            <FiltersMenu />
          </div>
        )}
        {common.selectedItem === "login" && <LoginForm />}
        {common.selectedItem === "signup" && <SignupForm />}
        {common.selectedItem === "mobileOTP" && <MobileOtpForm />}

        {common.selectedItem === "deposit" && (
          <div>
            <Headlines />
            <MobileDeposit />
          </div>
        )}
        {common.selectedItem === "withdraw" && (
          <div>
            <Headlines />
            <MobileWithdraw />
          </div>
        )}
        {(common.selectedItem === "depositCompleted" ||
          common.selectedItem === "withdrawCompleted") && (
            <div>
              <Headlines />
              <Completed />
            </div>
          )}
        {common.selectedItem === "forgotPassword" && (
          <div className="mobile--fp p-3">
            <ForgotPasswordActions />
          </div>
        )}
      </div>
      {modal.thanksPopupVisible && <Thanks />}
      {modal.openUsernameSetupModal && <UsernameSetup />}
      <ConditionalFooter isMobile={isMobile} playingGame={playingGame} />
      {/* Conditionally Render Signup Modal */}
      {modal.isSingupModalVisible && (
        <div className="modal-wrapper">
          <div className="modal-content">
            <SignupForm />
          </div>
        </div>
      )}
    </Router>
  );
}

// The browser would otherwise restore the old scroll position on a reload of
// the same URL (e.g. Menu › Settings while already on /profile).
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

/**
 * Every new page, and every mobile screen opened from the bottom bar or Menu
 * popup (deposit, withdraw, chat, ...), starts at the top instead of the
 * scroll position of the previous one.
 */
function ScrollToTop({ selectedItem }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, selectedItem]);

  return null;
}

function ConditionalTopNav() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isBettingScreen =
    (location.pathname.startsWith("/matka") ||
      location.pathname.startsWith("/makta")) &&
    searchParams.has("game");

  if (isBettingScreen) return null;

  return (
    <>
      <SideBarMenu />
      <Header />
    </>
  );
}

function ConditionalHeadlines() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isBettingScreen =
    (location.pathname.startsWith("/matka") ||
      location.pathname.startsWith("/makta")) &&
    searchParams.has("game");

  if (isBettingScreen) return null;

  return <Headlines />;
}

function ConditionalChatIcon({ isMobile, toggleChatBox }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isBettingScreen =
    (location.pathname.startsWith("/matka") ||
      location.pathname.startsWith("/makta")) &&
    searchParams.has("game");

  if (isBettingScreen || isMobile) return null;

  return (
    <div className="chatbox--icon">
      <img
        loading="lazy"
        src={chatBoxIcon}
        width={70}
        onClick={toggleChatBox}
        alt="kubera"
      />
    </div>
  );
}

function ConditionalFooter({ isMobile, playingGame }) {
  const location = useLocation();
  const isMatka =
    location.pathname.startsWith("/matka") ||
    location.pathname.startsWith("/makta");

  if (isMatka || playingGame) return null;

  return (
    <>
      {isMobile ? <MobileFooterMain /> : null}
      <Footer />
    </>
  );
}

export default App;
